import { useState } from 'react';
import { MdOutlineFileDownload } from 'react-icons/md';
import { Button } from '@Components/Button';
import { Appearance, Size } from '@Components/designConstants';
import { useSetError } from '@src/redux/modals';
import { exportMultiSheetToExcel } from '@src/utils/download-utils';

interface ExcelExportButtonProps {
  label: string;
  errorTitle: string;
  fileName: string;
  // Built on click, so large exports aren't computed until asked for.
  getSheets: () => { name: string; data: Record<string, unknown>[] }[];
  // The outlined look used on cards; the default is the filled button.
  outlined?: boolean;
}

// Downloads one or more sheets as an Excel file, reporting a failure through the app's error modal.
export const ExcelExportButton = ({
  label,
  errorTitle,
  fileName,
  getSheets,
  outlined
}: ExcelExportButtonProps) => {
  const [isExporting, setIsExporting] = useState(false);
  const setError = useSetError();

  const handleExport = async () => {
    setIsExporting(true);
    try {
      await exportMultiSheetToExcel(getSheets(), fileName);
    } catch (e) {
      setError({
        title: errorTitle,
        message: `${errorTitle}: ${e.message}`,
        reportError: e
      });
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Button
      size={Size.SM}
      appearance={outlined ? Appearance.OUTLINED : undefined}
      className='no-print'
      data-html2canvas-ignore='true'
      leadingElement={<MdOutlineFileDownload />}
      onClick={handleExport}
      loading={isExporting}
    >
      {label}
    </Button>
  );
};
